import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  change(event) {
    const { newValue } = event.detail
    this.element.classList.toggle("theme_dark", newValue)
    this.element.classList.toggle("theme_light", !newValue)
  }
}
